import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { Box, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import TestsRequests from "services/tests";

import QuizCheatsTableHeading from "./QuizCheatsTableHeading";
import QuizCheatTableItem from "./QuizCheatTableItems";


const QuizCheatsTable = () => {
  const dispatch = useDispatch();
  const { quizCheats, quizCheatsCurrentPage, quizCheatsTotalPages } = useSelector(
    ({ tests }) => tests
  );

  useEffect(() => {
    dispatch(TestsRequests.getQuizCheats(1));
  }, []);

  const handleChangePagination = (_, value) => {
    dispatch(TestsRequests.getQuizCheats(value));
  };

  return (
    <div className="Cmt-table-responsive">
      {quizCheats &&
        (quizCheats.length === 0 ? (
          <Box
            display={"flex"}
            justifyContent={"center"}
            paddingTop={"30px"}
            paddingBottom={"20px"}
          >
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <QuizCheatsTableHeading />
            </TableHead>
            <TableBody>
              {quizCheats.map((item) => (
                <QuizCheatTableItem
                  data={item}
                  key={item._id}
                />
              ))}
            </TableBody>
          </Table>
        ))}
      {quizCheats.length !== 0 ? (
        <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
          <Pagination
            count={quizCheatsTotalPages}
            color="primary"
            page={quizCheatsCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default QuizCheatsTable;